import { routeCreator } from "../../../helpers/routing/routeCreator";
import Specialties from "../pages/specialties";


export const ROUTE_PAGE_SPECIALTIES_INDEX = routeCreator(Specialties, '/specialties', 'Specialties', 'page.parameters', {exact: true})


const router = {
    ROUTE_PAGE_SPECIALTIES_INDEX,
    
}

export default router